import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MedicalLetterComponent } from './medical-letter-employee.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { JobTitleService } from '../../../../services/jobtitle/jobtitle.service';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { ClipboardModule } from 'ngx-clipboard';
import { EmployeeService } from '../../../../services/employee/employee.service';
import { TypeEmployeeService } from '../../../../services/type-employee/type-employee.service';
import { LightboxModule } from 'ngx-lightbox';
import { PersonGenderService } from '../../../../services/person-genders/person-gender.service';
import { ReportService } from '../../../../services/reports/report.service';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../../../../../../environments/environment';
import { AddMedicalLetterComponent } from './components/add-medical-letter/add-medical-letter.component';
import { MedicalLetterTypeService } from '../../../../services/medical-letter-types/medical-letter-type.service';
import { PersonService } from '../../../../services/person/person.service';
import { MedicalLetterService } from '../../../../services/medical-letter/medical-letter-service';
import { RelationshipService } from '../../../../services/relationships/relationship.service';


const routes = [
    {
        path: 'pages/management/medicalletters/:id',
        component: MedicalLetterComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_STUDENTS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        MedicalLetterComponent,
        AddMedicalLetterComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        ClipboardModule,
        LightboxModule,
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapsApiKey
        })
    ],
    exports: [
        MedicalLetterComponent
    ],
    entryComponents: [
        AddMedicalLetterComponent
    ],
    providers: [
        EmployeeService,
        PersonGenderService,
        JobTitleService,
        TypeEmployeeService,
        ReportService,
        MedicalLetterTypeService,
        PersonService,
        MedicalLetterService,
        RelationshipService
    ]
})

export class MedicalLetterEmployeeModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/medical-letter/medical-letter-employee.module.ts